import { Box } from "@mui/material";
import React from "react";
import Table from "../../../components/Table";
import { AMBASSADORS_TABLE_COLUMNS } from "../data/ReferralHelpers";
import { useSearchParams } from "react-router-dom";

const AmbassadorsTable = ({
  data,
  loading,
  totalRecords,
  rowsPerPage,
  onRowsPerPageChange,
}) => {
  const [searchParams] = useSearchParams();
  const limit = parseInt(searchParams.get("limit") || "10");
  const currentPage = parseInt(searchParams.get("offset") || "0") / limit + 1;

  return (
    <Box mt={0}>
      <Table
        columns={AMBASSADORS_TABLE_COLUMNS}
        data={data}
        progressPending={loading}
        paginationTotalRows={totalRecords}
        currentPage={currentPage}
        rowsPerPage={rowsPerPage}
        onRowsPerPageChange={onRowsPerPageChange}
      />
    </Box>
  );
};

export default AmbassadorsTable;
